import type { UnifiedLocationMetrics, UnifiedMetrics } from '@/models/metrics';
import { LOCATIONS } from '@/config/locations.ts';

export function createDefaultLocationMetrics(): UnifiedLocationMetrics {
  return {
    activeStudents: 0,
    studentTarget: null,
    activeEmployees: 0,
    feeSum: 0,
    feeSumActive: 0,
    feeSumDifference: 0,

    payingStudents: 0,
    averageSchoolFee: 0,
    lastBankImportAt: null,
    lastBankImportPeriodEnd: null,
    bankBalance: 0,
    lastPaymentReminderDate: null,
    openPaymentReminderSum: 0,
    paymentRemindersSentLastMonth: 0,
    financialCertsCreated: 0,
    financialCertsSent: 0,
    schoolFeeReductionCount: 0,
    schoolFeeReductionTotal: 0,
    schoolFeeReductionsByType: [],
    totalDifference: null,
    totalDifferenceBySchoolYear: [],

    averageAge: 0,
    amountMale: 0,
    amountFemale: 0,
    teacherCount: 0,
    staffCount: 0,
    pedagogicalHours: 0,
    pedagogicalLessons: 0,
    nonPedagogicalHours: 0,
    hoursByCategory: [],
    unassignedHours: {
      pedagogical: { hours: 0, lessons: 0 },
      non_pedagogical: { hours: 0, lessons: 0 }
    }
  };
}

export function createDefaultMetrics(): UnifiedMetrics {
  const metrics: UnifiedMetrics = {};

  LOCATIONS.forEach((location) => {
    metrics[location.name] = createDefaultLocationMetrics();
  });

  return metrics;
}
